import React , {Component} from "react";
import {  Formik, Form, Field } from 'formik';
import axios from 'axios';
import { MenuItem, LinearProgress, FormControlLabel, Typography, Grid, Breadcrumbs, Tooltip, Fab, Table,
TableBody, TableCell, TableHead, TableRow } 
from '@mui/material';
import * as yup from 'yup';
import {Link, useParams} from 'react-router-dom';
import { styled } from "@mui/material/styles";
import { connect } from 'react-redux';
import {ExcelRenderer} from 'react-excel-renderer';
import { TextField } from 'formik-mui';
import Button from "../../components/CustomButtons/Button.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components//Card/CardBody";
//import Table from "../../components//Table/Table.js";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { baseUrl } from '../../components//shared/baseUrl';
import withRouterCompat from '../../actions/routerWrapper.jsx';


const StyledcardCategory = styled('div')(({ theme }) => ({
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
}));

const StyledcardTitle = styled('div')(({ theme }) => ({
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
}));


const standard = [
    {
        value: 'VI',
        label: 'VI'
    },
    {
        value: 'VII',
        label: 'VII'
    },
    {
        value: 'VIII',
        label: 'VIII'
    },
    {
        value: 'IX',
        label: 'IX'
    },
    {
        value: 'X',
        label: 'X'
    },
    {
        value: 'XI',
        label: 'XI'
    },
    {
        value: 'XII',
        label: 'XII'
    }

]



const previewStyle = {
    maxHeight: "100px",
    maxWidth: "100px"
  }

  const validationSchema = yup.object().shape({
  
    title: yup
      .string()
      .min(6, "Title is too short "),
  
    description: yup
      .string()
      .min(2, "Too Short")
      .max(30, "Too Long!"),
    teachers:yup.array().of(
        yup.object().shape({
        value: yup
        .string()
        .email()
        .required()
    })
    )
  })


class CreateClass extends Component {

    constructor(props) {
        super(props)
        this.state = {
            file:'',
            url: '',
            expdisable:true,
            teachers:[],
            schemalist:[{
                "Name":'',
                "Email":''
            }],
            studentlist:[],
            rows:'',
            cols:'',
            uploadSuccess:false,
            uploadStudents:false,
            std:'',
            errorstudent:'',
            checkupload:false,
            checkvalidstudentemail:false,
            classimage:'',


        };

        this.handleUploadImage = this.handleUploadImage.bind(this);
        this.uploadbutton = this.uploadbutton.bind(this);
        this.handleUploadClick = this.handleUploadClick.bind(this);
        this.addcoTeacher = this.addcoTeacher.bind(this);
        this.removecoTeacher = this.removecoTeacher.bind(this);
        this.handlecoChange= this.handlecoChange.bind(this);
        this.handlestdChange= this.handlestdChange.bind(this);
        this.validateTitle=this.validateTitle.bind(this); 
        this.validateEmail=this.validateEmail.bind(this);
        this.validateStudent=this.validateStudent.bind(this);
        this.validateStd=this.validateStd.bind(this); 
        this.cancelImagebutton = this.cancelImagebutton.bind(this);
        this.cancelFilebutton = this.cancelFilebutton.bind(this);
       
        
       


    }

    cancelImagebutton() {
        this.setState({
          file:'',
          url:''
        });
      }
      cancelFilebutton() {
        this.setState({
          rows:'',
          uploadStudents:false,
          checkupload:false
        });
      }
    validateStudent(value) {
        let error;
        this.state.studentlist.map((student, index)=>{
            value=student.Email
            if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)){
                
                this.setState({
                    errorstudent:'Invalid email address of student',
                    checkvalidstudentemail:!this.state.checkvalidstudentemail
                  })
            }
        })
            this.setState({
                uploadStudents:!this.state.uploadStudents
              }) 
          
        return error;
      }

    handlestdChange(event){
        this.setState({
            std:event.target.value,
          })
    }

    validateStd(value) {
        let error;
        //console.log(value);
        if(this.state.std ==''){
              error = 'Every class must have standard'
           }
        return error;
      }
    validateEmail(value) {
        let error;
        this.state.teachers.map((teacher, index)=>{
            value=teacher.Email
            if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)){
                error = 'Invalid email address'
            }
        })
       

        return error;
      }

    validateTitle(value) {
        let error;
        //console.log(value.length);
        if(value.length==0){
            error = 'Every class must have a title'
        }
        else if(value.length<5){
              error = 'Title is too short'
           }
        else if(value.length>=30){
            error = 'Title too long'
        }
        return error;
      }






    uploadbutton(){
        const data=new FormData();
        //// imageFile is set as single key in backend 
        data.append('file', this.state.file)   
        let url = `${baseUrl}fileupload/files`;

    
        axios.post(url, data)
        .then(response => {
            this.setState({
                classimage:response.data.file.filename,
                uploadSuccess:!this.state.uploadSuccess,
              })
            //console.log(response)
        })
        .catch(errors => console.log(errors));
    
    }

handleUploadImage(event){
        // this.setState({
        //     file: event.target.files[0],
        //     url: URL.createObjectURL(event.target.files[0])
        //   })
          let reader = new FileReader();
          let file = event.target.files[0];
          this.setState({
            file: event.target.files[0],
          })
          var url = reader.readAsDataURL(file)
      
          reader.onloadend = () => {
            this.setState({
                url: reader.result,
              })
            }
          
          if(this.state.uploadSuccess===true){
            this.setState({
                uploadSuccess:!this.state.uploadSuccess
              }) 
          }
    };

handleUploadClick(event){
    let fileObj = event.target.files[0];
  
    ExcelRenderer(fileObj, (err, resp) => {
        if(err){
          console.log(err);            
        }
        else{
          this.setState({
            cols: resp.cols,
            rows: resp.rows
          });
        }

         this.setState({
             rows: this.state.rows.slice(1)
           });


        let t = []
         {this.state.rows.map((item, i) => (
            
             t[i] = {...item}

         ))}

         this.setState({
            studentlist:[]
        })

          {t.map((item, i) => (
            this.setState({
                studentlist: [...this.state.studentlist, {"Name":'' ,"Email":''}]
            }),
            
             this.state.studentlist[i].Name = item[0],
             this.state.studentlist[i].Email = item[1]
    
            //  console.log(i, item[0])
             
         ))}
         this.setState({
            studentlist:this.state.studentlist,
            errorstudent:'',
        })
        if(this.state.checkvalidstudentemail===true){
            this.setState({
                checkvalidstudentemail:!this.state.checkvalidstudentemail
            })
        }

        if(this.state.checkupload===false){
        this.setState({
            checkupload:!this.state.checkupload,
            uploadStudents:!this.state.uploadStudents
          })
        }
        else if(this.state.uploadStudents===false){
            this.setState({
                uploadStudents:!this.state.uploadStudents
              })
            }
        

    

      });               
      
    };



    addcoTeacher(){
        this.setState({
            teachers: [...this.state.teachers, {"Id":'' ,"Email":''}]
        })
    
    } 
    
    
    removecoTeacher(index){
        this.state.teachers.splice(index, 1)
        this.setState({
            teachers:this.state.teachers
        })
    }
    
    
    handlecoChange(e, index){
               
        //console.log(e.target.value)

        
        this.state.teachers[index].Email = e.target.value


        this.setState({
            teachers: this.state.teachers
        });


    
    }
    

       


    render(){
           
        const { classes } = this.props;

    //console.log(this.state.studentlist)
    //console.log(this.state.uploadStudents)

      
    
    
    return (
       
        <div>
           <GridContainer>
                <GridItem xs={12} sm={12} md={12}>

                    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                        <Link color="inherit" to="/admin/dashboard">
                            Dashboard
                        </Link>
                    <Typography color="textPrimary">Create Class</Typography>
                    </Breadcrumbs>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                        
                    <Card>
                        <CardHeader color="primary">
                            <StyledcardTitle>
                                <p>Enter basic details of class</p>
                            </StyledcardTitle>
                        </CardHeader>
                        {console.log(this.props.user)}
                <Formik
                    initialValues={{
                    title: '',
                    std:this.state.std,
                    teachers: this.state.teachers,

                    students:this.state.studentlist,
                    classimage:'',
                    // dateTime: new Date(),
                    }}

                    validationSchema={validationSchema}

                    onSubmit={(values, {setSubmitting}) => {
                    setTimeout(() => {
                        setSubmitting(false);

                        {(this.state.file !== '') ? values.classimage=this.state.classimage: values.classimage='assets/images/cimage.jpg' }
                        //console.log(JSON.stringify(this.state.teachers))
                        values.teachers = this.state.teachers
                        values.students = this.state.studentlist
                        values.std=this.state.std
                        
                       // alert(JSON.stringify(values, null, 2));

                        const classDetails = {
                            title: values.title,
                            teacherId:this.props.user.id,
                            image:values.classimage,
                            std:values.std,
                            coTeachers:values.teachers,
                            students:values.students,
                        }
                        console.log(classDetails);
                        axios.post(`${baseUrl}class`, classDetails)
                        .then(res => 
                            {
                                if(typeof this.props.params.modId !=='undefined'){
                                    window.location = `/admin/dashboard/createsession/${res.data._id}/${this.props.params.modId}`

                                }else{
                                window.location = "/admin/dashboard"
                                //console.log(res.data)
                                }   
                            });

                    }, 500);
                    }}
                >
                    {({submitForm, isSubmitting, touched, errors}) => (
                        <Form>
                         
                                <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                            component={TextField}
                                            type="text"
                                            label="Title"
                                            name="title"
                                            validate={this.validateTitle}

                                            />

                                        </GridItem>

                                        <GridItem xs={12} sm={12} md={4}>
                                            
                                            {
                                                this.state.teachers.map((teacher, index) =>{
                                                    return(
                                                        <div key={index} >

                                                            <Field
                                                                component={TextField}
                                                                type="text"
                                                                label="Enter email address of teacher"
                                                                name="email"
                                                                fullWidth= {true}
                                                                value={teacher.Email}
                                                                onChange={(e)=>this.handlecoChange(e, index)} 
                                                                validate={this.validateEmail}
                                                            />

                                                            <Tooltip
                                                                arrow
                                                                title="Click to remove teacher"
                                                                placement="bottom">
                                                                <Fab
                                                                color="default"
                                                                variant="extended"
                                                                size="small"
                                                                onClick={e => this.removecoTeacher(index)}
                                                                >
                                                                <RemoveIcon />
                                                                Remove Teacher
                                                                </Fab>
                                                            </Tooltip>
                                                        </div>
                                                    )
                                                })
                                            }
                                            <div>
                                            
                                            <Tooltip
                                                arrow
                                                title="Click to add new teacher"
                                                placement="bottom">
                                               <Fab
                                                variant="extended"
                                                color="default"
                                                size="small"
                                                onClick={this.addcoTeacher}
                                                >
                                                <AddIcon />
                                                Add Teacher 
                                               </Fab>
                                              
                                            </Tooltip>
                                            </div>
                                            
                                        </GridItem>
                                        
                                        <GridItem xs={12} sm={12} md={4}>

                                            <Field
                                            component={TextField}
                                            type="text"
                                            name="std"
                                            onChange={this.handlestdChange}
                                            validate={this.validateStd}
                                            value={this.state.std}
                                            label="std"
                                            select
                                            variant="standard"
                                            helperText="Please select"
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            >
                                            {standard.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                                </MenuItem>
                                            ))}
                                            </Field>

                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                            <p>Upload Details of students</p>
                                        <label htmlFor="student">
                                            <input
                                            accept=".xlsx,.xls"
                                            id="student"
                                            style={{ display: "none" }}
                                            multiple
                                            type="file"
                                            name="student"
                                            onChange={this.handleUploadClick}
                                            />
                                                <Fab color="secondary" aria-label="add" 
                                                    variant="extended"
                                                    size="medium"
                                                    component="span">
                                                    <AttachFileIcon /> Add Excel File
                                                </Fab>
                                        </label>
                                            {this.state.errorstudent}
                                            {this.state.checkupload===true?
                                            this.state.uploadStudents===true?
                                            <div>
                                            <Button color="success" onClick={this.validateStudent} 
                                            disabled={this.state.checkvalidstudentemail}>
                                                upload 
                                            </Button>
                                            <Button color="danger" onClick={this.cancelFilebutton}>
                                                cancel 
                                            </Button>
                                            </div>:
                                            this.state.checkvalidstudentemail===false?
                                            <p>uploaded successfully</p>:<p>Error Upload again</p>:null}
                                                
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                            <p>Upload image for Class</p>
                                            <label htmlFor="classimage">
                                                <input
                                                accept="image/*"
                                                style={{ display: "none" }}
                                                id="classimage"
                                                multiple
                                                type="file"
                                                name="classimage"
                                                label="Upload image here"
                                                onChange={this.handleUploadImage}
                                                />
                                                    <Fab color="secondary" aria-label="add" 
                                                        variant="extended"
                                                        size="medium"
                                                        component="span">
                                                        <InsertPhotoIcon /> Add Image
                                                    </Fab>
                                            </label>
                                            {this.state.file!=='' ?this.state.uploadSuccess!==true?
                                            <div>
                                            <Button color="success" onClick={this.uploadbutton}>
                                                upload 
                                            </Button>
                                            <Button color="danger" onClick={this.cancelImagebutton}>
                                                cancel 
                                            </Button></div>:<p>
                                                uploaded successfully
                                            </p>:null}
                                            <img src={this.state.url} style={previewStyle}/>
                                        </GridItem>

                                        

                                    {this.state.rows!=='' ? 
                                        <GridItem xs={12} sm={12} md={6}>
                                            <Card>
                                                <CardHeader color="warning">
                                                    <StyledcardTitle>
                                                        <h4>Student Details</h4>
                                                    </StyledcardTitle>
                                                </CardHeader>
                                                <CardBody>
                                                    <Table>
                                                        <TableHead key={"header"}>
                                                        {Object.keys(this.state.schemalist[0]).map((key) => (
                                                            <TableCell>{key}</TableCell>
                                                                    ))}
                                                        </TableHead>
                                                        <TableBody>
                                                        {this.state.studentlist.map((item) => (

                                                            <TableRow key={item.id}>
                                                                {Object.values(item).map((val) => (
                                                                <TableCell>{val}</TableCell>
                                                                ))}
                                                            </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </CardBody>
                                            </Card>
                                        </GridItem>

                                    :<div>{isSubmitting=true}Please enter student list</div>  }
                                    </GridContainer>
                                </CardBody>
                            
                           
                            {this.state.checkupload && isSubmitting && <LinearProgress />}
                            {console.log(!this.state.checkupload +''+ isSubmitting)}

                            
                            <GridItem xs={12}>
                                <Button
                                variant="contained"
                                color="primary"
                                disabled={!this.state.checkupload && isSubmitting}
                                onClick={submitForm}
                                >
                                Submit
                                </Button>
                            </GridItem>
                        </Form>
                     
                    )}
                </Formik>
            </Card>
        </GridItem>
        </GridContainer>
        </div>
      );

  }
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
    user: state.user
    }
  };
  export default connect(mapStateToProps)(withRouterCompat(CreateClass));